import React from "react";

export default function TermosUso() {
  return (
    <div className="container">
      <div className="d-flex justify-content-center">
        <div style={{ width: 393 }}>
          <div style={{ textAlign: "center", marginTop: 44, marginBlock: 16 }}>
            <h1>Termos de uso</h1>
          </div>
          <div style={{ height: "100vh" }}>
            <embed
              type="application/pdf"
              src="/termos_de_uso_-_Cashbarber-v2.pdf"
              id="pdfDocument"
              width="100%"
              height="100%"
            />
          </div>
        </div>
      </div>
    </div>
  );
}
